/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  CardHeader,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { DisplayCard } from '@schamburg-web/lakecounty';
import { useEffect, useState } from 'react';
import { titleCase } from 'title-case';
import CardCloseButton from '../../components/CardCloseButton/CardCloseButton';
import { getLocationDescription, getNormalizedIcon } from '../utils';
import MultipleSnapshotView from './MultipleSnapshotView';
import SingleSnapshotView from './SingleSnapshotView';

const CameraCard: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box
      sx={{
        maxWidth: '100vw',
        height: matches ? 'auto' : 'calc(100% - 150px)',
        borderRadius: 20,
        '& .MuiPaper-root': { background: 'inherit' },
      }}
    >
      {children}
    </Box>
  );
};

const CameraPopupCard: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const [snapTs, setSnapTs] = useState(new Date().getTime());
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  const normalizedIcon = getNormalizedIcon(icon);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  // Update snapTs every 5 minutes (300,000 milliseconds)
  useEffect(() => {
    const interval = setInterval(() => {
      setSnapTs(new Date().getTime());
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, []);

  return (
    <CameraCard>
      <DisplayCard icon={icon} module={module}>
        <CardHeader
          action={<CardCloseButton />}
          title={
            <Box textAlign={'center'} sx={{ position: 'relative' }}>
              <Typography variant="h6">
                {getLocationDescription(normalizedIcon)}
                {expandedIdx !== null && (
                  <Typography variant="h6" component="span">
                    {`  (${titleCase(
                      normalizedIcon.approaches.approach[expandedIdx].direction
                    )})`}
                  </Typography>
                )}
              </Typography>
            </Box>
          }
          sx={{
            padding: '5px',
            color: 'white',
            maxWidth: '100%',
            minWidth: matches ? '568px' : '100%',
          }}
          className="camera-header"
        />
        {expandedIdx === null ? (
          <MultipleSnapshotView
            approaches={normalizedIcon.approaches.approach}
            snapTs={snapTs}
            setExpandedIdx={setExpandedIdx}
          />
        ) : (
          <SingleSnapshotView
            approaches={normalizedIcon.approaches.approach}
            snapTs={snapTs}
            selectedIndex={expandedIdx}
            onClose={() => setExpandedIdx(null)}
            setExpandedIdx={setExpandedIdx}
          />
        )}
      </DisplayCard>
    </CameraCard>
  );
};

export default CameraPopupCard;
